var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-info btn-sm font-size-sm poppins",attrs:{"type":"button"},on:{"click":() => _vm.onClick(_vm.item.variable)}},[_vm._v(" "+_vm._s(_vm.item.name)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }